import { useState, useEffect, useCallback } from 'react';
import InvestorMetricsService from '../../../../../services/investor-metrics.service';

export const useRetentionMetrics = ({ dateRange = '30d', organization }) => {
  const [data, setData] = useState({
    retention7d: null,
    retention30d: null,
    dauMauStickiness: null,
    powerUserSegmentation: null,
    practiceRetention: null,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const [ret7d, ret30d, dauMau, powerUser, practiceRet] = await Promise.all([
        InvestorMetricsService.getPrescriberRetention7d({ dateRange, organization }),
        InvestorMetricsService.getPrescriberRetention30d({ dateRange, organization }),
        InvestorMetricsService.getDAUMAUStickiness({ dateRange, organization }),
        InvestorMetricsService.getPowerUserSegmentation({ dateRange, organization }),
        InvestorMetricsService.getPracticeRetention({ dateRange }),
      ]);

      setData({
        retention7d: ret7d,
        retention30d: ret30d,
        dauMauStickiness: dauMau,
        powerUserSegmentation: powerUser,
        practiceRetention: practiceRet,
      });
    } catch (err) {
      console.error('Error fetching retention metrics:', err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [dateRange, organization]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const refetch = useCallback(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch };
};
